import { useRef } from "react";
import { Box, TextField as MuiTextField, Typography } from "@mui/material";
import { FormikProps, getIn } from "formik";

interface ColorPickerProps {
  name: string;
  formik: FormikProps<any>;
  label?: string;
  placeholder?: string;
}

export default function ColorPicker({
  name,
  formik,
  label = "",
  placeholder,
}: ColorPickerProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const value = getIn(formik.values, name) || "#667eea";
  const error = getIn(formik.touched, name) && Boolean(getIn(formik.errors, name));
  const helperText = getIn(formik.touched, name) && getIn(formik.errors, name);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(name, e.target.value);
  };

  const handleBlur = () => {
    formik.setFieldValue(name, (getIn(formik.values, name) || "").toUpperCase());
    formik.setFieldTouched(name, true, false);
  };

  return (
    <Box>
      {/* <Typography
        sx={{
          fontSize: "0.8125rem",
          color: "text.primary",
          fontWeight: 500,
          mb: 0.5,
        }}
      >
        {label}
      </Typography> */}
      <MuiTextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
        error={error}
        helperText={helperText as string}
        inputProps={{ form: undefined }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "&:hover fieldset": {
              borderColor: "#667eea",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#667eea",
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#667eea",
          },
          mt: 0,
          mb: 0,
          "& .MuiInputBase-root": {
            cursor: "pointer",
          },
          "& .MuiInputBase-input": {
            cursor: "pointer",
          },
        }}
        InputProps={{
          startAdornment: (
            <Box
              onClick={() => inputRef.current?.click()}
              sx={{
                width: 26,
                height: 26,
                mr: 1,
                borderRadius: "6px",
                cursor: "pointer",
                border: "1px solid rgba(0,0,0,0.12)",
                background: value,
                flexShrink: 0,
              }}
            />
          ),
          endAdornment: (
            <Box
              component="span"
              className="material-symbols-outlined"
              sx={{
                fontSize: 18,
                color: "#94a3b8",
                cursor: "pointer",
              }}
              onClick={() => inputRef.current?.click()}
            >
              palette
            </Box>
          ),
        }}
      />
      <input
        ref={inputRef}
        type="color"
        value={/^#[0-9a-fA-F]{6}$/.test(value) ? value : "#667eea"}
        onChange={handleChange}
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          opacity: 0,
          pointerEvents: "none",
        }}
        tabIndex={-1}
        aria-hidden="true"
      />
    </Box>
  );
}